import { Button, Card, CardMedia, Divider, useTheme } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { ButtonGroupWithSelection } from 'framework/components/ButtonGroupWithSelection';
import { NoRecordsFound } from 'framework/components/NoRecordsFound';
import { SearchbarWithParams } from 'framework/components/search/SearchbarWithParams';
import { useQueryContext } from 'framework/hooks/useQueryContext';
import { onResetToPage1 } from 'framework/types/onResetToPage1';
import { useLocalization } from 'localization/useLocalization';
import React, { useContext } from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';
import { IReloadTriggerProps } from 'shared/layout/IReloadTriggerProps';
import { RestrictedContent } from 'shared/layout/RestrictedContent';
import { SelectColumnsButtonAndDialog } from 'shared/selectColumns/SelectColumnsButtonAndDialog';
import { CommissionsTable } from './CommissionsTable';
import { MyQueryContext } from './context/MyQueryContext';
import { ViewContext } from './context/ViewContext';
import { Filter } from './Filter';
import { CommissionForm } from './forms/CommissionForm';
import { QuickFilter, QuickFilters } from './QuickFilter';

export const MyCommissionsPage = ({ reloadTrigger }: IReloadTriggerProps) => {
	const strings = useLocalization();
	const theme = useTheme();
	const { params, setParams, queryResult, reload } = useQueryContext(MyQueryContext, reloadTrigger);
	const { columns, columnsRecord, setColumns, quickFilter, setQuickFilter, quickFilterRecord } = useContext(ViewContext);
	const { open, confirm, cancel } = useDialogsContext(reload);

	if (queryResult === undefined) {
		return <div></div>;
	}

	const onNew = () => {
		open(
			<CommissionForm
				confirm={confirm}
				cancel={cancel}
			/>
		);
	};

	return (
		<RestrictedContent pageClaim='MyCommissions'>
			<div
				className='df-row-ac jc-sb'
				style={{ marginBottom: '24px' }}>
				<SearchbarWithParams
					params={params}
					setParams={setParams}
					placeholder={strings.searchVerb}
					style={{ width: '400px' }}
					variant='paper'
				/>
				<Button
					variant='contained'
					color='primary'
					startIcon={<AddIcon />}
					onClick={onNew}>
					{strings.addWhat(strings.commission)}
				</Button>
			</div>
			{queryResult.unfilteredCount > 0 && (
				<>
					<Card>
						<div
							className='df-row-ac jc-sb'
							style={{ padding: theme.spacing(1) }}>
							<ButtonGroupWithSelection<QuickFilter>
								options={QuickFilters}
								selected={quickFilter}
								setSelected={setQuickFilter}
								renderOption={t => quickFilterRecord[t]}
							/>
						</div>
						<Divider />
						<div className='df-row'>
							<Filter
								params={params}
								onFilter={params => setParams(onResetToPage1(params))}
								paddingLeft={theme.spacing(1.5)}
							/>
							<div className='fg1'></div>
							<SelectColumnsButtonAndDialog
								selectedColumns={columns}
								setSelectedColumns={setColumns}
								record={columnsRecord}
								view='myCommissionsPage'
							/>
						</div>
						<Divider />
						<CardMedia>
							<CommissionsTable
								queryResult={queryResult}
								params={params}
								setParams={setParams}
								reload={reload}
							/>
						</CardMedia>
					</Card>
				</>
			)}
			{queryResult.unfilteredCount === 0 && <NoRecordsFound>{strings.noWhatDefined(strings.commissions)}</NoRecordsFound>}
		</RestrictedContent>
	);
};
